import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { IBankItem } from "web/types/Banks";
import { IPaymentSettingsItem } from "web/types/Payment";

import { BANK_PAYMENTS_TYPE } from "./consts";

const getActivePaymentSettings = (
  paymentSettings: IPaymentSettingsItem[],
  banks: IBankItem[]
) =>
  isArrayHasItems(paymentSettings)
    ? paymentSettings.filter(({ active, code, type }) => {
        return type === BANK_PAYMENTS_TYPE
          ? active &&
              isArrayHasItems(banks) &&
              banks.some(
                (bank) =>
                  bank &&
                  bank.points_bank_id === code &&
                  bank.blockade_locked === 0 &&
                  +bank.balance &&
                  +bank.balance > 0
              )
          : active;
      })
    : [];

export default getActivePaymentSettings;
